import { render, staticRenderFns } from "./CreateChannelAccount.vue?vue&type=template&id=0e924486&scoped=true&"
import script from "./CreateChannelAccount.vue?vue&type=script&lang=js&"
export * from "./CreateChannelAccount.vue?vue&type=script&lang=js&"
import style0 from "./CreateChannelAccount.vue?vue&type=style&index=0&id=0e924486&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e924486",
  null
  
)

export default component.exports